let GEO_JSON_DRAW_OBJ = {
    id: "lkm77m9871897abcd",
    type: "fill",
    source: {
        type: "geojson",
        data: {
            type: "Feature", //holy shit this HAS to be uppsercase F or else this wont work.
            geometry: {
                type: "Polygon",
                coordinates: []
            }
        }
    },
    layout: {},
    paint: {
        "fill-color": "#065FF2",
        "fill-opacity": 0.3,
        "fill-outline-color": "#F00"
    }
};

exports.GEO_JSON_DRAW_OBJ = GEO_JSON_DRAW_OBJ;
